//DefaultTable

import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, gridClasses, GridToolbar } from '@mui/x-data-grid';
import { Button } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'iD_Paleta';

export default function PaletizadosAdmin_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: keyField,
            sort: 'desc',
        },
    ]);
    const intl = useIntl();
    const columns = [
        {
            field: keyField,
            headerName: 'ID Paleta',
            width: 140,
            type: 'number'
        },
        {
            field: 'origin',
            headerName: intl.formatMessage({ id: 'Origen' }),
            editable: false,
            width: 60,
        },
        {
            field: 'packinG_DATE',
            headerName: intl.formatMessage({ id: 'Fecha de empaque' }),
            editable: false,
            width: 140,
            renderCell: (params) => {
                return params.row['packinG_DATE'].slice(0, 10)
            }
        },
        {
            field: 'grower',
            headerName: intl.formatMessage({ id: 'Productor' }),
            editable: false,
            width: 240,
        },
        {
            field: 'packing',
            headerName: intl.formatMessage({ id: 'Packing' }),
            editable: false,
            width: 90,
        },
        {
            field: 'brand',
            headerName: intl.formatMessage({ id: 'Brand' }),
            editable: false,
            width: 120,
        },
        {
            field: 'fruit',
            headerName: intl.formatMessage({ id: 'Fruit' }),
            editable: false,
            width: 60,
        },
        {
            field: 'variety',
            headerName: intl.formatMessage({ id: 'Variety' }),
            editable: false,
            width: 140,
        },
        {
            field: 'description',
            headerName: intl.formatMessage({ id: 'Tipo de Fruta' }),
            editable: false,
            width: 140,
        },
        {
            field: 'boxeS_ON_PALLET',
            headerName: intl.formatMessage({ id: 'Cajas por paleta' }),
            editable: false,
            width: 120,
        },
        {
            field: 'vesseL_NAME',
            headerName: intl.formatMessage({ id: 'Vapor' }),
            editable: false,
            width: 120,
        },
        {
            field: 'voyagE_NUMBER',
            headerName: intl.formatMessage({ id: 'Viaje' }),
            editable: false,
            width: 120,
        },
        {
            field: 'loaD_PORT',
            headerName: intl.formatMessage({ id: 'Destino' }),
            editable: false,
            width: 120,
        },
        {
            field: 'loaD_DATE',
            headerName: intl.formatMessage({ id: 'Fecha de carga' }),
            editable: false,
            width: 140,
            renderCell: (params) => {
                return params.row['loaD_DATE'].slice(0, 10)
            }
        },
        {
            field: 'container',
            headerName: intl.formatMessage({ id: 'Contenedor' }),
            editable: false,
            width: 120,
        },
        {
            field: 'deck',
            headerName: intl.formatMessage({ id: 'Deck' }),
            editable: false,
            width: 60,
        },
        {
            field: 'hold',
            headerName: intl.formatMessage({ id: 'Hold' }),
            editable: false,
            width: 60,
        },
        {
            field: 'art',
            headerName: intl.formatMessage({ id: 'Art' }),
            editable: false,
            width: 60,
        },
        {
            field: 'supplier',
            headerName: intl.formatMessage({ id: 'Supplier' }),
            editable: false,
            width: 80,
        },
        {
            field: 'containeR_NUM',
            headerName: intl.formatMessage({ id: 'Contenedor' }),
            editable: false,
            width: 120,
        },
        {
            field: 'finca',
            headerName: intl.formatMessage({ id: 'Finca' }),
            editable: false,
            width: 80,
        },
        {
            field: 'puerto',
            headerName: intl.formatMessage({ id: 'Puerto' }),
            editable: false,
            width: 80,
        },
    ];

    return (
        <div>
            {/*<Toolbar>*/}
            {/*    <div className="row" style={{ width: '100%' }}>*/}
            {/*        <div className="col">*/}
                        
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    */}{/*<Button className="AddButton" style={{ whiteSpace: 'nowrap' }} onClick={() => {*/}
            {/*    */}{/*    props.add_onclick()*/}
            {/*    */}{/*}}><AddIcon /> Agregar</Button>*/}
            {/*</Toolbar>*/}
            <Box sx={{
                height: 600, width: '100%',
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}
                />
            </Box>
        </div>
    );
}
